import styles from '../../assets/styles/Login/Login.module.scss';
import MimaInput from '../../components/MimaInput';
import { MimaButton } from '../../components';
import { Formik } from 'formik';
import React from 'react';

const ForgotPasswordForm = ({ validationSchema, onSubmit, loading }) => {
	return (
		<Formik
			initialValues={{
				email: '',
			}}
			validationSchema={validationSchema()}
			onSubmit={onSubmit}>
			{({
				handleChange,
				handleBlur,
				handleSubmit,
				values,
				errors,
				touched,
			}) => (
				<div>
					<MimaInput
						labelTitle="Email address"
						type="text"
						placeholder="Enter your email address"
						id="email"
						value={values.email}
						onChange={handleChange}
						onBlur={handleBlur}
						error={errors.email}
						touched={touched.email}
					/>

					<MimaButton
						title="Reset Password"
						onClick={handleSubmit}
						type="submit"
						loading={loading}
						variant="form"
					/>
				</div>
			)}
		</Formik>
	);
};

export default ForgotPasswordForm;
